<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">

  <div style="padding-bottom: 10px;">
    <h4>Partnership Details</h4>
  </div>

  <div style="margin-bottom: 20px;">
    <!-- Partnership Details Table -->
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th rowspan="2">LEID</th>
          <th rowspan="2">Reporting Period</th>
          <th rowspan="2">Name</th>
          <th rowspan="2">US Tax Type</th>
          <th rowspan="2">Tax Year Begin</th>
          <th rowspan="2">Tax Year End</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{PSHIP_LEID}}</td>
          <td>{{PSHIP_REPORTING_PERIOD}}</td>
          <td>{{PSHIP_NAME}}</td>
          <td>{{PSHIP_US_TAX_TYPE}}</td>
          <td>{{PSHIP_BEGIN_DATE}}</td>
          <td>{{PSHIP_END_DATE}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="padding-bottom: 10px;">
    <h4>Partner Setup</h4>
  </div>

  <div class="table-scroll">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          @if (userType >= 2 && userType <= 5) {
<th rowspan="2">&nbsp;</th>
}
          <th rowspan="2">LEID</th>
          <th rowspan="2">Reporting Period</th>
          <th rowspan="2" style="width:150px;">Name</th>
          <th rowspan="2">US Tax Type</th>
          <th rowspan="2" class="col-ownership">Effective Ownership %</th>
          <th rowspan="2" class="col-date-begin">Effective Date Begin</th>
          <th rowspan="2" class="col-date-end">Effective Date End</th>
          <th rowspan="2">Inactive</th>
          <th rowspan="2">Initial K1</th>
          <th rowspan="2">Final K1</th>
        </tr>
      </thead>
      <tbody>
        @if (userType >= 2 && userType <= 5) {
<tr>
          <td colspan="1">
            @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
            @if (!loading) {
<i class="fa fa-plus-circle color-green fa-lg pull-left"
               style="cursor: pointer; margin-top: 4px;"
               title="{{tooltipMsg}}"
               (click)="addPartner()"></i>
}
          </td>
          @if (partnerCount == 0) {
<td colspan="10" align="left"><b>{{emptyPartnerLabel}}</b></td>
}
          @if (partnerCount != 0) {
<td colspan="10" align="center">&nbsp;</td>
}
        </tr>
}

        <!-- Existing Partners List -->
        @for (row of partnerList; track $index; let i = $index) {
<tr>
          @if (userType >= 2 && userType <= 5) {
<td>
            <i class="fa fa-pencil bluepencil pull-left"
               style="cursor: pointer; margin-top: 4px;"
               title="Edit Existing Partner"
               (click)="editExistingPartner(i)">
            </i>
            @if (row.delete) {
<i class="fa fa-minus-circle color-red fa-lg pull-right"
               style="cursor: pointer; margin-top: 4px;"
               title="Remove Existing Partner"
               (click)="removeExistingPartner(i)">
            </i>
}
          </td>
}
          <td width="7%">{{row.PARTNER_LEID}}</td>
          <td width="10%" align="center">{{row.PARTNER_REPORTING_PERIOD}}</td>
          <td width="15%">{{row.PARTNER_NAME}}</td>
          <td align="center">{{row.PARTNER_US_TAX_TYPE}}</td>
          @if (row.view && !row.edit) {
<td align="right" style="white-space: nowrap">{{row.EFFECTIVE_OWNERSHIP_PERCENTAGE}}</td>
}
          @if (!row.view && row.edit) {
<td align="right">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="number" 
                         required 
                         placeholder="Decimal" 
                         pattern="^[0-9]{1,3}(\.[0-9]{0,6})?$" 
                         step="0.000001"
                         [(ngModel)]="row.EFFECTIVE_OWNERSHIP_PERCENTAGE" 
                         class="form-control input-sm numText" 
                         style="text-align: right; width:100px" 
                         (ngModelChange)="mark_dirty(i); adjustEffectiveOwnershipPercentage(row);"
                         (blur)="handleOwnershipBlur(row)" />
                </td>
              </tr>
              @if (row.has_ownership_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_ownership_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (row.view && !row.edit) {
<td align="center" style="white-space: nowrap">{{row.EFFECTIVE_DATE_BEGIN}}</td>
}
          @if (!row.view && row.edit) {
<td align="left" width="10%">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="date" 
                         class="form-control input-sm" 
                         [(ngModel)]="row.EFFECTIVE_DATE_BEGIN" 
                         (ngModelChange)="mark_dirty(i)"
                         (keydown)="$event.preventDefault()"
                         (paste)="$event.preventDefault()" />
                </td>
              </tr>
              @if (row.has_beg_date_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_beg_date_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (row.view && !row.edit) {
<td align="center" style="white-space: nowrap">{{row.EFFECTIVE_DATE_END}}</td>
}
          @if (!row.view && row.edit) {
<td align="left" width="10%">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="date" 
                         class="form-control input-sm" 
                         [(ngModel)]="row.EFFECTIVE_DATE_END" 
                         (ngModelChange)="mark_dirty(i)"
                         (keydown)="$event.preventDefault()"
                         (paste)="$event.preventDefault()" />
                </td>
              </tr>
              @if (row.has_end_date_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_end_date_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (row.view && !row.edit) {
<td align="center">{{ showYesNo(row.IS_PTR_INACTIVE)}}</td>
}
          @if (!row.view && row.edit) {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.IS_PTR_INACTIVE == 1" 
                   (change)="row.IS_PTR_INACTIVE = row.IS_PTR_INACTIVE == 1 ? 0 : 1; mark_dirty(i)">
          </td>
}

          @if (row.view && !row.edit) {
<td align="center">{{ showYesNo(row.PTR_K1_INITIAL)}}</td>
}
          @if (!row.view && row.edit) {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.PTR_K1_INITIAL == 1" 
                   (change)="row.PTR_K1_INITIAL = row.PTR_K1_INITIAL == 1 ? 0 : 1; mark_dirty(i)">
          </td>
}

          @if (row.view && !row.edit) {
<td align="center">{{ showYesNo(row.PTR_K1_FINAL)}}</td>
}
          @if (!row.view && row.edit) {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.PTR_K1_FINAL == 1" 
                   (change)="row.PTR_K1_FINAL = row.PTR_K1_FINAL == 1 ? 0 : 1; mark_dirty(i)">
          </td>
}
        </tr>
}

        <!-- New Partners to Add List -->
        @for (row of partnerListToAdd; track $index; let i = $index) {
<tr>
          <td>
            <i class="fa fa-minus-circle color-red fa-lg pull-right"
               style="cursor: pointer; margin-top: 4px;"
               title="Remove Row"
               (click)="removePartnerToAdd(i)">
            </i>
          </td>
          @if (add == 'y') {
<td colspan="2">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="position: relative; border: none;">
                  <select class="form-control input-sm" 
                          [(ngModel)]="row.selectedPtrLeidRp"
                          (change)="loadPartnerAttributes(row.selectedPtrLeidRp, i)"
                          style="width: 100%;">
                    @for (eligiblePartner of eligiblePartnerList1; track $index) {
<option 
                            [value]="eligiblePartner.PTR_LEID_RP"
                            [ngClass]="{'bold': eligiblePartner.PTR_LE.includes('Choose')}">
                      {{eligiblePartner.PTR_LE}}
                    </option>
}
                  </select>
                </td>
              </tr>
              @if (row.has_ptr_sel_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_ptr_sel_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}

          @if (add == 'y') {
<td width="15%"><label>{{row.PARTNER_NAME}}</label></td>
}
          @if (add == 'y') {
<td align="center"><label>{{row.PARTNER_US_TAX_TYPE}}</label></td>
}
          @if (add == 'y') {
<td align="right">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="number" 
                         required 
                         placeholder="Decimal" 
                         pattern="^[0-9]{1,3}(\.[0-9]{0,6})?$" 
                         step="0.000001"
                         [(ngModel)]="row.EFFECTIVE_OWNERSHIP_PERCENTAGE" 
                         class="form-control input-sm numText" 
                         style="text-align: right; width:100px" 
                         (ngModelChange)="adjustEffectiveOwnershipPercentage(row);"
                         (blur)="handleOwnershipBlur(row)" />
                </td>
              </tr>
              @if (row.has_ownership_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_ownership_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (add == 'y') {
<td align="left" width="10%">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="date" 
                         class="form-control input-sm" 
                         [(ngModel)]="row.EFFECTIVE_DATE_BEGIN"
                         (keydown)="$event.preventDefault()"
                         (paste)="$event.preventDefault()" />
                </td>
              </tr>
              @if (row.has_beg_date_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_beg_date_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (add == 'y') {
<td align="left" width="10%">
            <table style="width: 100%; border: none;">
              <tr>
                <td style="border: none;">
                  <input type="date" 
                         class="form-control input-sm" 
                         [(ngModel)]="row.EFFECTIVE_DATE_END"
                         (keydown)="$event.preventDefault()"
                         (paste)="$event.preventDefault()" />
                </td>
              </tr>
              @if (row.has_end_date_err) {
<tr>
                <td style="border: none;">
                  @if (row.has_end_date_err) {
<span class="form-error-container">{{genericErrMsg}}</span>
}
                </td>
              </tr>
}
            </table>
          </td>
}
          @if (add == 'y') {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.IS_PTR_INACTIVE == 1" 
                   (change)="row.IS_PTR_INACTIVE = row.IS_PTR_INACTIVE == 1 ? 0 : 1">
          </td>
}
          @if (add == 'y') {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.PTR_K1_INITIAL == 1" 
                   (change)="row.PTR_K1_INITIAL = row.PTR_K1_INITIAL == 1 ? 0 : 1">
          </td>
}
          @if (add == 'y') {
<td align="center">
            <input type="checkbox" 
                   [checked]="row.PTR_K1_FINAL == 1" 
                   (change)="row.PTR_K1_FINAL = row.PTR_K1_FINAL == 1 ? 0 : 1">
          </td>
}
        </tr>
}

        <!-- Total Row -->
        @if (partnerList.length > 0 || partnerListToAdd.length > 0) {
<tr>
          @if (userType >= 2 && userType <= 5) {
<td>&nbsp;</td>
}
          <td width="8%"></td>
          <td></td>
          <td></td>
          <td align="right">Total %</td>
          <td align="right">{{totalEffectiveOwnershipPercentageToShow | number : '1.3-3'}}</td>
          <td align="right"></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
}
      </tbody>
    </table>
  </div>

  <div>
    <table style="width:300px; margin: 20px auto 0 auto;" border="0" cellspacing="0" cellpadding="0">
      @if (HAS_ERROR) {
<tr>
        <td>@if (HAS_ERROR) {
<span class="form-error-container">{{ERROR_MESSAGE}}</span>
}</td>
      </tr>
}
    </table>
  </div>

</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if ((userType >= 2 && userType <= 5) && !loading) {
<button
          class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (userType >= 2 && userType <= 5) {
<button
          class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

